import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../reduxService';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { EProjectType, unit } from '../../enum/project';

const initialState: IInitialState<IProjectInfoForm> = {
    initialState: true,
    data: {
        unit: '', designerFirmCity: '', owner: '', designerFirmName: '', designerFirmCountry: '', projectName: '',
        projectType: '', coordinates: [undefined, undefined],
        productCountry: null, nrProject: '0', notes: '', hasBeenSent: false
    },
};

export const projectInfoSlice = createSlice({
    name: 'projectInfo',
    initialState,
    reducers: {
        cleanProjectInfo: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setProjectInfo: (state, action: PayloadAction<IProjectInfoForm>) => {
            state.initialState = !action.payload.projectId;
            state.data = action.payload;
        },
        setProjectInfoTemplate: (state, action: PayloadAction<IProjectInfoForm>) => {
            state.initialState = false;
            state.data = { ...action.payload, ...state.data, projectType: action.payload.projectType, unit: action.payload.unit };
        },
        setHasBeenSent: (state, action: PayloadAction<boolean>) => {
            state.data = { ...state.data, hasBeenSent: action.payload } as IProjectInfoForm;
        },
    },
});

export const { setProjectInfo, cleanProjectInfo, setProjectInfoTemplate, setHasBeenSent } = projectInfoSlice.actions;

export const selectProjectInfo = (state: RootState) => state.projectInfo;
export const selectMacro1 = (state: RootState) => state.Macro1;
export const selectMacro2 = (state: RootState) => state.Macro2;

export default projectInfoSlice.reducer;
